<template>
  <div>
    <div>
      <div class="tasks-title-box w-100 rounded">
        <v-row class="ma-5">
          <v-col class="my-auto mx-auto mobile-d-none"><h3>پروژه ها</h3></v-col>
          <v-col class="text-left"  xs="12">
            <v-btn class="elevation-0" large @click="create_view.dialog=true;">
              <v-icon small >mdi-plus</v-icon>
              <div class="mobile-d-none">افزودن پروژه</div>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="last-changes rounded-lg container">
      <h2 class="text-center mb-3">پروژه های ثبت شده</h2>
        <v-data-table
            dense
            :loading="loading_projects"
            hide-default-footer
            :headers="projects_table.headers"
            :items="search_field?filter_by_names(projects_table.desserts, search_field):projects_table.desserts"
            class="elevation-0"
        >

          <template v-slot:item.status="{ item }">
            <v-tooltip top color="gray" max-width="50em">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                       :color="item.status?'success':'red'"
                       @click="change_status_id=item.id;change_status(item.id)"
                       prepend-icon="mdi-vuetify"
                       rounded outlined
                       class="my-4"
                       :loading="change_status_id===item.id && change_status_btn_loading"
                >
                  <v-icon :color="item.status?'success':'red'">{{ item.status ? 'mdi-check' : 'mdi-close' }}</v-icon>
                </v-btn>
              </template>
              برای تغییر وضعیت کلیک کنید
            </v-tooltip>
          </template>

          <template v-slot:item.img="{ item }">
            <v-img :src="item.img" max-width="200px" class="my-3 mx-auto"></v-img>
          </template>

          <template v-slot:item.remove="{ item }">
            <v-btn
                   prepend-icon="mdi-trash-can"
                   class=" rounded-pill "
                   color="error" text large
                   @click="remove_view.project=item;remove_view.dialog=true;"
            >
              حذف
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      <v-pagination
          v-if="projects_count > 10"
          v-model="page"
          color="#D20003"
          rounded
          @input="get_projects()"
          :length="projects_count%10!==0?parseInt(projects_count/10)+1:parseInt(projects_count/10)"
          :total-visible="7"
      ></v-pagination>
      </div>


    <v-dialog v-model="create_view.dialog" scrollable height="10vh" width="30em">
      <v-card>
        <v-card-title>
          <h3 class="mx-auto">افزودن پروژه</h3>
        </v-card-title>
        <v-card-text>
        <v-divider></v-divider>
          <v-container>
            <v-text-field v-model="create_view.project.title" rounded outlined label="عنوان"></v-text-field>
            <v-file-input v-model="create_view.project.img" rounded outlined label="تصویر پروژه"></v-file-input>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding: 0 !important;" v-if="create_view.project.title && create_view.project.img">
          <v-btn block large
                 class="elevation-0 rounded-0 text-bold"
                 color="success"
                 @click="create_project()" :loading="create_view.loading">
            افزودن
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>
    <v-dialog
        v-if="remove_view.project"
        v-model="remove_view.dialog"
        persistent
        max-width="500"
        class="br-1em"
    >
      <v-card class="br-1em">
        <v-card-title>
          <h3 class="mx-auto">
            آیا میخواهید این پروژه را حذف کنید ؟
          </h3>
        </v-card-title>
        <v-card-actions class="text-center pb-5">
          <v-spacer></v-spacer>

          <v-btn
              color="green"
              @click="remove_view.dialog = false"
              large text
              class="elevation-0"
          >
            بازگشت
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              class="elevation-0"
              :loading="remove_view.loading"
              @click="remove_project(remove_view.project['id'])"
          >
            حذف
            <small>`{{ remove_view.project.title }}`</small>
          </v-btn>
          <v-spacer></v-spacer>

        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'HomeManageProjects',
  data:()=>({
    key: localStorage.getItem('key'),
    create_project_dialog:false,
    loading_projects: false,
    project_form:{},
    search_items:[],
    search_field:null,
    projects_count:0,
    page:1,
    remove_view:{
      dialog: false,
      loading:false,
      project:null,
    },
    change_status_id:null,
    create_view:{
      dialog: false,
      loading:false,
      project: {title:null, img:null},
    },
    change_status_btn_loading:false,
    projects_table: {
      headers: [
        {text: 'شماره',align: 'center', value: 'id'},
        {text: 'عنوان',align: 'center', value: 'title'},
        {text: 'عکس',align: 'center', value: 'img'},
        {text: 'وضعیت',align: 'center', value: 'status'},
        {text: 'حذف',align: 'center', value: 'remove'},
      ],
      desserts:[],
    },
  }),
  created() {
    this.get_projects();
  },
  methods:{
    async get_projects(){
      this.loading_projects = true;
      try {
        const response = await axios.get(`${this.BACKEND_LINK}/api/account-admin/home-projects/?page=${this.page}`,{
          headers: {'Authorization': `Token ${this.key}`}
        });
        if (response.data){
          this.projects_count = response.data.count;
          this.projects_table.desserts = response.data.results;
        }
      } catch (error) {
        this.$snotify.error(`در دریافت مشکلی به وجود آمد. کد : ${error.response.status}`, 'دریافت اطلاعات');
      } finally {
        this.loading_projects = false;
      }
    },
    change_status(id){
      this.change_status_btn_loading = true;
      let status = new FormData();
      axios.put(`${this.BACKEND_LINK}/api/account-admin/home-projects/change-status/${id}`,status,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        if(response.data.status) {
          this.$snotify.success(response.data.msg, 'تغییر وضعیت');
          this.get_projects();
        }
        else {
          this.$snotify.error(`در تغییر وضعیت مشکلی به وجود آمد. کد : ${response.status}`, 'تغییر وضعیت');
        }
        this.change_status_btn_loading = false;
      }).catch((error)=>{
        this.$snotify.error(`در تغییر وضعیت مشکلی به وجود آمد. کد : ${error.response.status}`, 'تغییر وضعیت');
        this.change_status_btn_loading = false;
      })
    },
    remove_project(id){
      this.remove_view.loading = true;
      axios.delete(`${this.BACKEND_LINK}/api/account-admin/home-projects/change-status/${id}`,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        if (response.status === 204) {
          this.$snotify.success(`پروژه با موفقیت حذف شد.`, 'حذف پروژه');

          this.remove_view.loading = false;
          this.remove_view.project = false;
          this.remove_view.dialog = false;
          this.get_projects();

        }
      }).catch((error)=>{
        this.$snotify.error(`در حذف پروژه مشکلی به وجود آمد. کد : ${error.response.status}`, 'حذف پروژه');
        this.change_status_btn_loading = false;
        this.remove_view.loading = false;
      })
    },
    change_search_field(){
      this.search_items=this.projects_table.desserts;
    },
    create_project (){
      this.create_view.loading = true;
      let project = new FormData();
      project.append('title', this.create_view.project.title);
      project.append('img', this.create_view.project.img);
      axios.post(`${this.BACKEND_LINK}/api/account-admin/home-projects/`,project ,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        if(response.status === 201) {
          this.create_view.project = {title:null, img:null};
          this.$snotify.success(`پروژه با موفقیت ثبت شد.`, 'ثبت پروژه');
          this.create_view.loading = false;
          this.create_view.dialog = false;


          this.get_projects();
        }
        else {
          this.$snotify.error(`در ثبت پروژه مشکلی به وجود آمد. کد : ${error.response.status}`, 'ثبت پروژه');
        }
        this.create_view.loading = false;
      }).catch((error)=>{
        this.$snotify.error(`در ثبت پروژه مشکلی به وجود آمد. کد : ${error.response.status}`, 'ثبت پروژه');
        this.create_view.loading = false;
      })
    },

  }
}
</script>
